import React, {Fragment, useState, useRef, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Explanation_text from './Explanation_text';
import CancelIcon from '@material-ui/icons/Cancel';
import TagFacesIcon from '@material-ui/icons/TagFaces';
import {TextField, Typography} from '@material-ui/core';
import {FieldArray} from 'react-final-form-arrays';
import {connect} from 'react-redux';
const useStyles = makeStyles(theme => ({
  root: {display: 'flex', width:'calc(100% - 50px)', marginLeft:'20px', justifyContent: 'center', flexWrap: 'wrap', borderTopLeftRadius:'0%', borderTopRightRadius:'0%', padding: theme.spacing(0.5),},
  chip: {margin: theme.spacing(0.5), fontSize:'10px', height:'16px'},
}));


function ChipsArray(props) {
  const classes = useStyles();
  let  input_ref=useRef();

  function checkEnterClick(e){
    if(e.key=='Enter' && e.target.value!=''){
      e.stopPropagation(); e.preventDefault();
      let block=false;
      for(let v of props.value){
        if(v[props.value_name]==e.target.value){block=true;}}
        if(props.max_entries!=undefined && props.value!=undefined && props.value.length>=props.max_entries){block=true;}
        if(block==false){
          let new_value=(props.value==undefined || props.value=='')?[]:JSON.parse(JSON.stringify(props.value));
          if(e.target.dataset.editChip!=undefined && e.target.dataset.editChip!='none'){
            if(props.edited_values!=undefined && props.onChangeEditedValues!=undefined){
              let edited_values=JSON.parse(JSON.stringify(props.edited_values)); if(edited_values==''){edited_values={};}
              let done_EV=false; for(let original in edited_values){if(edited_values[original]==new_value[e.target.dataset.editChip][props.value_name]){if(original==e.target.value){delete edited_values[original]}else{ edited_values[original]=e.target.value;} done_EV=true;}}if(done_EV==false){edited_values[new_value[e.target.dataset.editChip][props.value_name]]=e.target.value;}
              props.onChangeEditedValues(edited_values);
          }
            new_value[e.target.dataset.editChip]={js_id:new_value[e.target.dataset.editChip].js_id}; new_value[e.target.dataset.editChip][props.value_name]=e.target.value;
            e.target.dataset.editChip='none';
            props.onChange([]);
            props.fields.concat(new_value)
          }else{
            let x={js_id:'internal_'+props.unique_id}; x[props.value_name]=e.target.value;
            new_value.push(x);
            props.fields.push(x);
            props.increase_unique_id();
          }
          if(props.onUpdate!=undefined){props.onUpdate(new_value);};
          e.target.value=''
      }
    }
  }
  function click_chip(index, value){
    input_ref.current.value=value;
    input_ref.current.dataset.editChip=index;
  }

  return (
    <Fragment>
    <TextField  style={(props.style==undefined)?{width:(props.width!=undefined)?'300px':'calc(100% - 40px)', marginLeft:'20px', marginTop:'30px', marginBottom:'0px'}:{width:(props.width!=undefined)?'300px':'calc(100% - 40px)', marginLeft:'20px', marginTop:'30px', marginBottom:'0px', ...props.style}}
    type={props.type}
    error={false}
    fullWidth
    margin='dense'
    label={(props.no_title==true)?"":<Explanation_text text={props.title}/>}
    name={'new_'+props.name}
    variant='standard'
    inputRef={input_ref}
    onKeyPress={(e)=>{checkEnterClick(e, props);}}
    InputLabelProps={null} />
    <div>
    <Paper className={classes.root} style={{width:props.width}}>
      {(props.value=="" || props.value.length==0)?
        <div><Typography style={{color:'grey'}} variant='caption'>{'Press enter to add '}<Explanation_text variant='caption' text={props.title}/></Typography></div>
        :<Chips {...props} onClick={click_chip} onDelete={()=>{input_ref.current.dataset.editChip='none'; input_ref.current.value=''}}/>}
    </Paper>
    </div>
    </Fragment>
  );
}

function Chips(props){
    let icon
    let return_array=[];
    for( var index in props.value){
      return_array.push(
        <Single_chip {...props} index_id={index} value={props.value[index]} icon={icon}/>
    )}
    return return_array;
}

function Single_chip(props){
  const classes=useStyles(props)
  const handleDelete = key => () => {let new_value=[]; let i=0; for(let x of props.fields.value){if(i!=key){new_value.push(x);} i+=1;}; props.fields.remove(key); props.onDelete(); props.onUpdate(new_value);};
  return(
  <Chip
    size='small'
    variant='outlined'
    color='primary'
    key={props.value.js_id}
    icon={props.icon}
    inputLabelProps={{shrink:true}}
    label={props.value[props.value_name]}
    onDelete={handleDelete(props.index_id)}
    onClick={(e)=>{props.onClick(props.index_id, props.value[props.value_name])}}
    deleteIcon={<CancelIcon color='secondary' style={{width:'12px', height:'12px'}}/>}
    className={classes.chip}
  />
  )
}

function Array(props){
  let first_time=useRef(true);
  useEffect(()=>{
    if(props.initial_value!=undefined && props.initial_value!=''){
      let nv=[]; let i=0; for(let v of props.initial_value){nv.push({js_id:i, text:v}); i+=1;} props.onChange(''); props.onChange(nv);
    }
  },[]);


  return(
    <FieldArray name={props.name}>
    {({fields})=>{
      if(first_time.current==true){
        if(props.initial_value!=undefined && props.initial_value!=''){let nv=[]; let i=0; for(let v of props.initial_value){fields.push({js_id:i, text:v}); i+=1;}}
        first_time.current=false;
      }
      return(<ChipsArray {...props} value={(fields.value==undefined)?'':fields.value} value_name={(props.value_name!=undefined)?props.value_name:'value'} fields={fields}/>)}}
    </FieldArray>
  )
}


export default connect(ss, dd)(Array);

function ss(state){
  return {
    unique_id:state.account.unique_id,
  }}

function dd(dispatch){
  return{
    increase_unique_id:()=>{dispatch({type:'UNIQUE_ID_INCREASE'})}
  }}
